// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"40924022","3":"40924022","476":"40924022","804":"40924022"}[chunkId] + ".chunk.css";
};